var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import Typography from '../typography/index.react';
import { createStyleWrapper, createButtonStyle } from './createStyle';
import Icon from '../../components/icon/index.react';

var getIcon = function getIcon(status) {
  switch (status) {
    case 'error':
      return 'alert-circle';

    case 'success':
      return 'checkmark-circle';

    default:
      return 'info-circle';
  }
};

var MessageBox = function MessageBox(_a) {
  var children = _a.children,
      _b = _a.status,
      status = _b === void 0 ? 'general' : _b,
      _c = _a.border,
      border = _c === void 0 ? false : _c,
      _d = _a.close,
      close = _d === void 0 ? false : _d,
      className = _a.className,
      onClick = _a.onClick,
      props = __rest(_a, ["children", "status", "border", "close", "className", "onClick"]);

  return React.createElement(Typography, __assign({
    as: "div",
    type: "caption"
  }, props, {
    className: createStyleWrapper({
      status: status,
      border: border,
      close: close,
      className: className
    })
  }), React.createElement(Icon, {
    name: getIcon(status)
  }), React.createElement(Typography, {
    type: "caption"
  }, children), close && React.createElement("button", {
    className: createButtonStyle(),
    type: "button",
    onClick: onClick
  }, React.createElement(Icon, {
    name: "close",
    size: "xs"
  })));
};

export default MessageBox;